import type { LoadableType } from '@confluence/loadable';
import { LoadableAfterPaint } from '@confluence/loadable';
import type { EditorAppearanceButtonNextProps } from '../src/EditorAppearanceButtonNext.tsx';

export const EditorAppearanceButtonNext: LoadableType<
	Omit<EditorAppearanceButtonNextProps, 'flags'>
> = LoadableAfterPaint({
	loader: async () => {
		const { EditorAppearanceButtonNext } = await import(
			/* webpackChunkName: "loadable-EditorAppearanceButtonNext" */ '../src/EditorAppearanceButtonNext.tsx'
		);
		return EditorAppearanceButtonNext;
	},
});
